import styled from 'styled-components'

export const ItemRightContentContainer = styled.div`
  margin-left: 8px;
`
